import React from 'react';
import withIcon from '../utilities/withIcon';

const IconUsersGroup = () => {
  return (
    <g>
      <path d="m12.4665 9.1189c-1.2526 0-1.91-1.9691-1.407-3.0737a1.5678 1.5678 0 0 1 2.8139 0c.5031 1.1048-.1544 3.0737-1.4069 3.0737z" />
      <path d="m12.66 12.1179h3.28c0-2.434-.8423-1.724-2.1234-2.5565a.3423.3423 0 0 0 -.4446.0556l-.7206.7254a.288.288 0 0 1 -.185.0771c-.0065 0-.01-.0041-.0159-.0046a5.41 5.41 0 0 1 .2095 1.703z" />
      <path d="m3.5334 9.1189c-1.2526 0-1.91-1.9691-1.4069-3.0737a1.5074 1.5074 0 0 1 1.4069-.876 1.5074 1.5074 0 0 1 1.4069.876c.5031 1.1048-.1543 3.0737-1.4069 3.0737z" />
      <path d="m3.5585 10.4121c-.01.0013-.015.0073-.0252.0073a.2879.2879 0 0 1 -.1849-.0771c-.2343-.2357-.7208-.7254-.7208-.7254a.3423.3423 0 0 0 -.4447-.0556c-1.2807.8325-2.1229.1225-2.1229 2.5566h3.2918a5.4688 5.4688 0 0 1 .2067-1.7058z" />
      <path d="m9.6029 9.0951a.4048.4048 0 0 0 -.5258.0658l-.8521.8576a.308.308 0 0 1 -.4374 0l-.8522-.8576a.4048.4048 0 0 0 -.5254-.0658c-1.5144.9843-2.51.1448-2.51 3.0227h8.214c-.0006-2.8778-.9965-2.0384-2.5111-3.0227z" />
      <path d="m8.0064 8.5521c-1.481 0-2.2583-2.3281-1.6635-3.6342a1.7823 1.7823 0 0 1 1.6635-1.0358 1.7823 1.7823 0 0 1 1.6636 1.0358c.5947 1.3061-.1826 3.6342-1.6636 3.6342z" />
    </g>
  );
};

export default withIcon(IconUsersGroup);
